<template>
  <div class="allbox">
    <el-table :data="appInfo" style="width: 100%;" border>
      <el-table-column
        prop="label"
        label="字段名"
        width="200px"
      />
      <el-table-column
        prop="value"
        label="值"
      >
        <template v-slot="scope">
          {{ scope.row.value }}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>

export default {
  props: {
    app_info: {
      type: Object
    }
  },
  data() {
    return {
      labelMapping: [
        { key: 'downloadTypeText', label: '下载方式' },
        { key: 'appName', label: '推广APP名称' },
        { key: 'apkName', label: '推广APP包名' },
        { key: 'appUrl', label: '推广APP链接' },
        { key: 'channelId', label: '渠道包ID' },
        { key: 'openurl', label: '应用商店直投链接' },
        { key: 'docId', label: 'doc id' },
        { key: 'appId', label: '应用id' }
      ],
      appInfo: []
    }
  },
  watch: {
    app_info: {
      immediate: true,
      handler(val) {
        this.sendr(val)
      }
    }
  },
  created() {},
  methods: {
    sendr(row) {
      this.appInfo = this.labelMapping
        // eslint-disable-next-line no-prototype-builtins
        .filter(item => row.hasOwnProperty(item.key))
        .map(item => {
          return {
            label: item.label,
            value: row[item.key] || ''
          }
        })
    }
  }
}
</script>

<style scoped>
.allbox {
  padding: 30px;
}
</style>
